import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import FeedbackForm from './FeedbackForm';
import LanguageSwitcher from './LanguageSwitcher';

const LandingPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="landing-page">
      {/* Navigation */}
      <nav className="navbar">
        <div className="nav-container">
          <div className="nav-brand">
            <span className="brand-text">{t('nav.brand')}</span>
          </div>
          <div className="nav-links">
            <LanguageSwitcher />
            <Link to="/browser" className="nav-link">{t('nav.launchApp')}</Link>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              {t('hero.title')}
            </h1>
            <p className="hero-subtitle">
              {t('hero.subtitle')}
            </p>
          </div>

          {/* Alternative Platforms Reference */}
          <div className="alternatives-section">
            <p className="alternatives-text">
              {t('hero.alternatives')}
            </p>
          </div>

          {/* Terminal Window */}
          <div className="terminal">
            <div className="terminal-header">
              <div className="terminal-controls">
                <span className="terminal-dot terminal-dot-red"></span>
                <span className="terminal-dot terminal-dot-yellow"></span>
                <span className="terminal-dot terminal-dot-green"></span>
              </div>
              <span className="terminal-title">{t('hero.terminalTitle')}</span>
            </div>
            <div className="terminal-content">
              <div className="terminal-prompt">
                <span className="prompt-symbol">$</span>
                <span className="prompt-text">{t('hero.terminalPrompt')}</span>
              </div>
              <div className="terminal-output">
                <span>{t('hero.terminalOutput.line1')}</span><br/>
                <span>{t('hero.terminalOutput.line2')}</span><br/>
                <span>{t('hero.terminalOutput.line3')}</span><br/>
                <span>{t('hero.terminalOutput.line4')}</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-header">
              <div className="feature-icon">🌐</div>
              <h3 className="feature-title">{t('features.browserIDE.title')}</h3>
            </div>
            <p className="feature-description">
              {t('features.browserIDE.description')}
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-header">
              <div className="feature-icon">⚡</div>
              <h3 className="feature-title">{t('features.instantDev.title')}</h3>
            </div>
            <p className="feature-description">
              {t('features.instantDev.description')}
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-header">
              <div className="feature-icon">🤝</div>
              <h3 className="feature-title">{t('features.collaborative.title')}</h3>
            </div>
            <p className="feature-description">
              {t('features.collaborative.description')}
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-header">
              <div className="feature-icon">🎨</div>
              <h3 className="feature-title">{t('features.codeEditor.title')}</h3>
            </div>
            <p className="feature-description">
              {t('features.codeEditor.description')}
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-header">
              <div className="feature-icon">🚀</div>
              <h3 className="feature-title">{t('features.deployTest.title')}</h3>
            </div>
            <p className="feature-description">
              {t('features.deployTest.description')}
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-header">
              <div className="feature-icon">📁</div>
              <h3 className="feature-title">{t('features.githubIntegration.title')}</h3>
            </div>
            <p className="feature-description">
              {t('features.githubIntegration.description')}
            </p>
          </div>
        </div>
      </section>

      {/* 用户反馈组件 */}
      <FeedbackForm />
    </div>
  );
};

export default LandingPage;